module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAdCAYAAABSZrcyAAAACXBIWXMAAAsSAAALEgHS3X78AAAApElEQVRIDe3XQQ3DMAyF4b/R7iuEMWkgDIqNxIEyCC2TQugQZPLUShsB+5In5fzJSeQ4U+8dVX0AvqKym9k+iUgFXsA9EH8DzwLUYJjTqyUY/YvjDdiCXffa98JlJX3bBz7wsNwcUlUB5kD3MLPmvd1hSyhcS3DFv5kdP5Lw43rPc8589PaBDzwi3l7nc3ReAt3tGp0lGOb0JP3CrUn2mvdXM9s/6mk09BWa4/kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/toNav.png
// module id = kpdD
// module chunks = 1